/* 同意文表示 */
import React, { useEffect } from 'react';
import { handleBrowzerBack } from '../BrowzerBack';
var AgreementDocument = function (_a) {
    var check_box_title = _a.check_box_title, doc = _a.doc;
    useEffect(function () {
        // ブラウザの戻る・進む禁止
        handleBrowzerBack();
    }, []);
    return (React.createElement("div", { className: "p-review-box row" },
        React.createElement("div", { className: "agreement-document col-md-10 col-12 mx-auto" },
            React.createElement("div", { className: "agreement-document-body card mx-2 mx-md-5 px-3" }, doc))));
};
export default AgreementDocument;
